import { R_BADGE } from 'components/common';
import { PerkSortDir, PerkSortField, PerkStatus } from './types';

export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 9;
export const DEFAULT_USER_PERKS_PAGE_SIZE = 6;
export const DEFAULT_DASHBOARD_PERKS_PAGE_SIZE = 4;
export const DEFAULT_SORT_FIELD: PerkSortField = 'published_at';
export const DEFAULT_SORT_DIR: PerkSortDir = 'desc';

export const PERK_STATUSES = {
  AVAILABLE: 0,
  UNLOCKED: 1,
  FROM_YUMMY_BROS: 2,
  UPCOMING: 3,
};

export const LABEL_BY_PERK_STATUS = {
  [PERK_STATUSES.AVAILABLE]: 'Available Perks',
  [PERK_STATUSES.UNLOCKED]: 'Unlocked',
  [PERK_STATUSES.UPCOMING]: 'Coming Soon',
  [PERK_STATUSES.FROM_YUMMY_BROS]: `From Yummy Bros${R_BADGE}`,
};

export const QUERY_STRING_BY_STATUS: Record<number, PerkStatus> = {
  [PERK_STATUSES.AVAILABLE]: 'available',
  [PERK_STATUSES.UNLOCKED]: 'unlocked',
  [PERK_STATUSES.UPCOMING]: 'upcoming',
  [PERK_STATUSES.FROM_YUMMY_BROS]: 'from-yummy-bros',
};

export const VALIDITY_DATE_FORMAT = 'DD MMM YYYY';

export const PERK_LAYOUT_IDS = {
  card: 'card',
  cardImage: 'card-image',
  cardCta: 'card-cta',
  cardValidity: 'card-validity',
  cardTitle: 'card-title',
  cardProgress: 'card-progress',
  cardPartner: 'card-partner',
};

export const PERK_TYPES = {
  INTERNAL_GENERIC: 'internal-generic',
  INTERNAL_UNIQUE: 'internal-unique',
  PARTNER_GENERIC: 'partner-generic',
  PARTNER_UNIQUE: 'partner-unique',
  PARTNER_MANUAL: 'partner-manual',
};
